// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app_38e8x"};